/* eslint-disable */

import {
  signInWithEmailAndPassword,
  MultiFactorError,
  browserLocalPersistence,
  browserSessionPersistence,
  setPersistence,
} from "@firebase/auth";
import React from "react";
import { FirebaseError } from "firebase/app";
import { LoginCredentials } from "@freetech/models/user";
import { auth } from "@/config/firebase";
import { apiClient } from "@/api";

export const handleLoginWithEmail = async (
  { email, password, rememberMe }: LoginCredentials,
  setUserInfo: React.Dispatch<any>
): Promise<MultiFactorError | FirebaseError | void> => {
  try {
    await setPersistence(
      auth,
      rememberMe ? browserLocalPersistence : browserSessionPersistence
    );

    await signInWithEmailAndPassword(auth, email, password);

    return;
  } catch (error: any) {
    console.error(`Email login attempt failed:`, {
      error,
      code: error?.code,
      message: error?.message,
      name: error?.name,
    });

    if (
      error?.code === "auth/multi-factor-auth-required" ||
      error?.code === "auth/invalid-credential" ||
      error?.code === "auth/browser-not-supported" ||
      (error?.message &&
        (error.message.includes("ReCAPTCHA") ||
          error.message.includes("AppCheck")))
    ) {
      throw error;
    }

    if (
      error?.code !== "auth/internal-error" ||
      !error?.message?.includes("Cloud function deadline exceeded")
    ) {
      throw error;
    }
  } finally {
    apiClient.shared.trackLogin();
  }
};
